var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-icon",
    className: "home-icon",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8,16.7c-0.3,0-0.6-0.2-0.7-0.5l-2-6.1l-2.7,6.2c-0.2,0.4-0.6,0.5-1,0.4S5.8,16,6,15.7l3.5-7.9c0.1-0.3,0.4-0.5,0.7-0.4 c0.3,0,0.6,0.2,0.7,0.5l2.6,7.9c0.1,0.4-0.1,0.8-0.5,0.9C13,16.7,12.9,16.7,12.8,16.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9,12.6H7.5v1.5h4.4V12.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,16.7c-0.4,0-0.8-0.5-0.8-1V8.3c0-0.6,0.3-1,0.8-1s0.8,0.5,0.8,1v7.3C17.1,16.2,16.8,16.7,16.3,16.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15,22.7H9c-5.4,0-7.8-2.3-7.8-7.7V9c0-5.4,2.3-7.8,7.8-7.8h6c5.4,0,7.8,2.3,7.8,7.8v6C22.8,20.4,20.4,22.7,15,22.7z  M9,2.7C4.4,2.7,2.8,4.4,2.8,9v6c0,4.6,1.6,6.2,6.3,6.2h6c4.6,0,6.3-1.6,6.3-6.2V9c0-4.6-1.6-6.3-6.3-6.3H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAnalytics);
export default __webpack_public_path__ + "static/media/ai-analytics.ab66ee09054f5d639f8260c4804d014a.svg";
export { ForwardRef as ReactComponent };